// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar-container {
    display: flex;
    align-items: center;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50px;
    width: 80%;
    height: 60px;
    padding: 0 25px;
    margin: 0 auto;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

/* Light Highlight Animation */
/* Shine animation removed */

.searchBar-container:focus-within {
    border-color: var(--primary-color);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.txt-input {
    border: none;
    outline: none;
    font-size: 1.1rem;
    width: 100%;
    background: transparent;
    color: var(--text-color);
    font-family: var(--font-family);
    font-weight: 300;
}

.txt-input::placeholder {
    color: rgba(0, 0, 0, 0.3);
}

.searchbar-icon-container {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-left: 15px;
    z-index: 2;
    /* Keep above animation */
}

.searchbar-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    filter: none;
    /* Dark icons for light bg */
    opacity: 0.6;
}

.searchbar-icon:hover {
    opacity: 1;
    transform: scale(1.1);
}

#send-btn:hover {
    filter: drop-shadow(0 0 5px var(--primary-color));
}

#mic-btn:hover {
    filter: drop-shadow(0 0 10px var(--primary-color));
    opacity: 1;
    transform: scale(1.15);
}

/* Pulsating Animation for Listening Mode */
@keyframes pulsate-primary {
    0% {
        box-shadow: 0 0 0 0 rgba(62, 142, 158, 0.6);
    }

    70% {
        box-shadow: 0 0 0 20px rgba(62, 142, 158, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(62, 142, 158, 0);
    }
}

.searchbar-icon.listening {
    border-radius: 50%;
    background-color: var(--primary-color);
    padding: 12px;
    box-sizing: content-box;
    /* To accommodate padding without shrinking icon */
    filter: drop-shadow(0 0 15px var(--primary-color));
    opacity: 1;
    animation: pulsate-primary 1.5s infinite;
}

.searchbar-stop-btn {
    background: #ff4d4f !important;
    color: #ffffff !important;
    border: none;
    padding: 8px 18px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
    white-space: nowrap;
}

.searchbar-stop-btn:hover {
    background: #ff7875 !important;
    transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/searchBar/searchBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA,8BAA8B;AAC9B,4BAA4B;;AAE5B;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,kDAAkD;IAClD,UAAU;IACV,sBAAsB;AAC1B;;AAEA,2CAA2C;AAC3C;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,kDAAkD;IAClD,kDAAkD;IAClD,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B","sourcesContent":[".searchBar-container {\n    display: flex;\n    align-items: center;\n    background: #ffffff;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 50px;\n    width: 80%;\n    height: 60px;\n    padding: 0 25px;\n    margin: 0 auto;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n/* Light Highlight Animation */\n/* Shine animation removed */\n\n.searchBar-container:focus-within {\n    border-color: var(--primary-color);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.txt-input {\n    border: none;\n    outline: none;\n    font-size: 1.1rem;\n    width: 100%;\n    background: transparent;\n    color: var(--text-color);\n    font-family: var(--font-family);\n    font-weight: 300;\n}\n\n.txt-input::placeholder {\n    color: rgba(0, 0, 0, 0.3);\n}\n\n.searchbar-icon-container {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-left: 15px;\n    z-index: 2;\n    /* Keep above animation */\n}\n\n.searchbar-icon {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    filter: none;\n    /* Dark icons for light bg */\n    opacity: 0.6;\n}\n\n.searchbar-icon:hover {\n    opacity: 1;\n    transform: scale(1.1);\n}\n\n#send-btn:hover {\n    filter: drop-shadow(0 0 5px var(--primary-color));\n}\n\n#mic-btn:hover {\n    filter: drop-shadow(0 0 10px var(--primary-color));\n    opacity: 1;\n    transform: scale(1.15);\n}\n\n/* Pulsating Animation for Listening Mode */\n@keyframes pulsate-primary {\n    0% {\n        box-shadow: 0 0 0 0 rgba(62, 142, 158, 0.6);\n    }\n\n    70% {\n        box-shadow: 0 0 0 20px rgba(62, 142, 158, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(62, 142, 158, 0);\n    }\n}\n\n.searchbar-icon.listening {\n    border-radius: 50%;\n    background-color: var(--primary-color);\n    padding: 12px;\n    box-sizing: content-box;\n    /* To accommodate padding without shrinking icon */\n    filter: drop-shadow(0 0 15px var(--primary-color));\n    opacity: 1;\n    animation: pulsate-primary 1.5s infinite;\n}\n\n.searchbar-stop-btn {\n    background: #ff4d4f !important;\n    color: #ffffff !important;\n    border: none;\n    padding: 8px 18px;\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 600;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);\n    white-space: nowrap;\n}\n\n.searchbar-stop-btn:hover {\n    background: #ff7875 !important;\n    transform: scale(1.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
